// extracted by mini-css-extract-plugin
export var avatarContainer = "_5c-0";
export var avatarTypingWave = "_5c-i";
export var gray = "_5c-f";
export var green = "_5c-c";
export var icon = "_5c-9";
export var image = "_5c-1";
export var lg = "_5c-6";
export var md = "_5c-5";
export var presenceDot = "_5c-b";
export var red = "_5c-d";
export var sm = "_5c-4";
export var status = "_5c-a";
export var typingDot = "_5c-h";
export var typingPill = "_5c-g";
export var xl = "_5c-7";
export var xs = "_5c-3";
export var xxl = "_5c-8";
export var xxs = "_5c-2";
export var yellow = "_5c-e";